import { useI18n } from "vue-i18n";

const guard =
  (translate) =>
  (key, ...args) =>
    key === null || key === undefined || typeof key === "object"
      ? ""
      : translate(key, ...args);

export default function useSafeI18n() {
  const i18n = useI18n();
  return { ...i18n, t: guard(i18n.t) };
}

export { guard };
